var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDashboardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 586.6 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.7,46.6v10.5h-35.3v15.7h35.3v10.4h-35.3v15.6h35.3v10.5h-45.7v-62.8h45.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.9,46.6c8.7,0,16.1,3.1,22.2,9.2,6.2,6.1,9.3,13.5,9.3,22.2s-2,12.8-5.9,18.2l5.9,5.8-7.5,7.4-5.8-5.8c-5.5,3.9-11.5,5.8-18.2,5.8s-16.1-3.1-22.2-9.2c-6.1-6.1-9.2-13.5-9.2-22.2s3.1-16,9.2-22.2c6-6.1,13.4-9.2,22.2-9.2ZM268.9,57.1c-5.7,0-10.7,2.1-14.8,6.1-4,4.1-6.1,9-6.1,14.7s2,10.7,6.1,14.8c4.2,4,9.1,6.1,14.8,6.1s10.6-2,14.7-6.1c4.1-4.2,6.1-9.1,6.1-14.8s-2.1-10.6-6.1-14.7c-4.1-4.1-9-6.1-14.7-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.5,83.3c0,7.2-2.6,13.4-7.7,18.5-5.2,5.1-11.4,7.6-18.5,7.6s-13.3-2.5-18.4-7.6c-5.1-5.2-7.6-11.4-7.6-18.5v-36.6h10.4v36.6c0,4.3,1.5,8,4.5,11,3.1,3.1,6.8,4.6,11.1,4.6s8-1.5,11-4.6c3.1-3.1,4.7-6.8,4.7-11v-36.6h10.5v36.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412.3,46.6h10.4v52.3h31.4v10.5h-41.8v-62.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484,46.6h10.4v62.8h-10.4v-62.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M573.3,46.6h13.3l-24.5,31.4,24.5,31.4h-13.3l-17.9-22.9-17.8,22.9h-13.4l24.6-31.4-24.6-31.4h13.4l17.8,22.9,17.9-22.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.7,156l65.7-39.1V39.1L65.7,0,0,39.1v77.9l65.7,39.1ZM124.5,108.9l-71.2-42.9,12.4-7.2,58.8,33.7v16.5ZM124.5,84.5l-58.8-33.7-19.2,11.1-14.6-8.8,33.8-19.5,58.8,33.7v17.2ZM65.7,8l58.8,35v16.4l-58.8-33.7-40.5,23.4-14.2-8.5L65.7,8ZM6.9,47.1l71.2,42.9-12.4,7.2L6.9,63.6v-16.5ZM6.9,71.5l58.8,33.7,19.2-11.1,14.6,8.8-33.8,19.5L6.9,88.7v-17.2ZM6.9,96.6l58.8,33.7,40.5-23.4,14.2,8.5-54.7,32.5L6.9,113.1v-16.4Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.2,
    y1: 49.1,
    x2: 37.9,
    y2: 56.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.7 30 65.7 50.8 83 40.4 65.7 30"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.7 4.9 65.7 25.7 83 15.3 65.7 4.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.7 52.7 65.7 73.5 83 63.1 65.7 52.7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDashboardLogo);
export default __webpack_public_path__ + "static/media/user-dashboard-logo.cb23afbd864a82a0ac7533d99e4fc9b4.svg";
export { ForwardRef as ReactComponent };